import HeaderTopbar from './headerTopbar'

const headerTopbar = new HeaderTopbar()
headerTopbar.init()
